import { render, staticRenderFns } from "./ChangeDay.vue?vue&type=template&id=2d5f1a61&scoped=true&"
import script from "./ChangeDay.vue?vue&type=script&lang=js&"
export * from "./ChangeDay.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDay.vue?vue&type=style&index=0&id=2d5f1a61&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f1a61",
  null
  
)

export default component.exports